<template>
  <div class="sys-settings">

    <!-- Tab 导航 -->
    <div class="settings-tabs">
      <span
        v-for="item in navItems"
        :key="item.key"
        class="tab-item"
        :class="{ active: activeTab === item.key }"
        @click="activeTab = item.key"
      >{{ item.label }}</span>
    </div>

    <!-- 内容区 -->
    <div class="settings-content">

      <!-- 个人信息 -->
      <div v-if="activeTab === 'profile'" class="content-card">
        <div class="card-head">
          <h3>基本资料</h3>
          <p>更新您的个人资料和联系方式</p>
        </div>
        <div class="card-body">
          <div class="field-row">
            <div class="field">
              <label>用户名</label>
              <el-input v-model="profile.username" disabled prefix-icon="el-icon-user" placeholder="用户名"></el-input>
              <span class="field-hint">用户名不可修改</span>
            </div>
            <div class="field">
              <label>姓名</label>
              <el-input v-model="profile.name" prefix-icon="el-icon-postcard" placeholder="请输入姓名"></el-input>
            </div>
          </div>
          <div class="field-row">
            <div class="field">
              <label>邮箱</label>
              <el-input v-model="profile.email" prefix-icon="el-icon-message" placeholder="请输入邮箱"></el-input>
            </div>
            <div class="field">
              <label>手机号</label>
              <el-input v-model="profile.phone" prefix-icon="el-icon-phone" placeholder="请输入手机号"></el-input>
            </div>
          </div>
          <div class="card-footer">
            <el-button type="primary" class="save-btn" @click="saveProfile" :loading="saving">
              <i class="el-icon-document-checked"></i> 保存修改
            </el-button>
          </div>
        </div>
      </div>

      <!-- 修改密码 -->
      <div v-if="activeTab === 'password'" class="content-card">
        <div class="card-head">
          <h3>修改密码</h3>
          <p>定期更换密码以确保账号安全</p>
        </div>
        <div class="card-body">
          <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm">
            <div class="field">
              <label>当前密码</label>
              <el-input v-model="passwordForm.oldPassword" type="password" show-password prefix-icon="el-icon-lock" placeholder="请输入当前密码"></el-input>
            </div>
            <div class="field">
              <label>新密码</label>
              <el-input v-model="passwordForm.newPassword" type="password" show-password prefix-icon="el-icon-key" placeholder="请输入新密码（至少6位）"></el-input>
            </div>
            <div class="field">
              <label>确认密码</label>
              <el-input v-model="passwordForm.confirmPassword" type="password" show-password prefix-icon="el-icon-key" placeholder="请再次输入新密码"></el-input>
            </div>
            <div class="card-footer">
              <el-button type="primary" class="save-btn" @click="changePassword" :loading="changingPwd">
                <i class="el-icon-document-checked"></i> 修改密码
              </el-button>
            </div>
          </el-form>
        </div>
      </div>

      <!-- 通知设置 -->
      <div v-if="activeTab === 'notification'" class="content-card">
        <div class="card-head">
          <h3>通知选项</h3>
          <p>选择您希望通过哪些渠道接收系统消息</p>
        </div>
        <div class="card-body">
          <div class="switch-row" v-for="item in notifyItems" :key="item.key">
            <div class="switch-icon">
              <i :class="item.icon"></i>
            </div>
            <div class="switch-info">
              <span class="switch-label">{{ item.label }}</span>
              <span class="switch-desc">{{ item.desc }}</span>
            </div>
            <el-switch v-model="notification[item.key]" active-color="#409eff"></el-switch>
          </div>
          <div class="card-footer">
            <el-button type="primary" class="save-btn" @click="saveNotification">
              <i class="el-icon-document-checked"></i> 保存设置
            </el-button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSettings',

  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }

    return {
      activeTab: 'profile',
      saving: false,
      changingPwd: false,
      navItems: [
        { key: 'profile', label: '个人信息' },
        { key: 'password', label: '修改密码' },
        { key: 'notification', label: '通知设置' }
      ],
      notifyItems: [
        { key: 'email', label: '邮件通知', desc: '通过邮件接收系统通知和提醒', icon: 'el-icon-message' },
        { key: 'sms', label: '短信通知', desc: '通过短信接收重要的操作确认', icon: 'el-icon-chat-dot-square' },
        { key: 'formSubmit', label: '问卷提交通知', desc: '有新的问卷提交时发送通知', icon: 'el-icon-document-copy' }
      ],
      profile: {
        username: '',
        name: '',
        email: '',
        phone: ''
      },
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      notification: {
        email: true,
        sms: false,
        formSubmit: true
      }
    }
  },

  computed: {
    userInfo() {
      return this.$store.getters.userInfo || {}
    }
  },

  mounted() {
    this.profile = {
      username: this.userInfo.username || '',
      name: this.userInfo.name || '',
      email: this.userInfo.email || '',
      phone: this.userInfo.phone || ''
    }
  },

  methods: {
    saveProfile() {
      this.saving = true
      setTimeout(() => {
        this.saving = false
        this.$message.success('保存成功')
      }, 500)
    },

    async changePassword() {
      try {
        await this.$refs.passwordForm.validate()
        this.changingPwd = true
        setTimeout(() => {
          this.changingPwd = false
          this.$message.success('密码修改成功，请重新登录')
          localStorage.removeItem('ACCESS_TOKEN')
          window.location.href = '/login'
        }, 500)
      } catch (e) {
        // 验证失败
      }
    },

    saveNotification() {
      this.$message.success('保存成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.sys-settings {
  min-height: 100%;
  background: #f0f2f5;
  padding: 0 32px 32px;
}

/* Tab 导航 */
.settings-tabs {
  display: flex;
  gap: 32px;
  padding-top: 16px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 24px;

  .tab-item {
    padding: 12px 0;
    font-size: 14px;
    color: #64748b;
    cursor: pointer;
    position: relative;
    transition: color 0.2s;
    user-select: none;
    outline: none;
    border: none;
    background: none;

    &:hover {
      color: #409eff;
    }

    &.active {
      color: #409eff;
      font-weight: 600;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -1px;
        height: 3px;
        background: #409eff;
        border-radius: 2px 2px 0 0;
      }
    }
  }
}

/* 内容卡片 */
.content-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  max-width: 720px;
}

.card-head {
  padding: 24px 28px 0;

  h3 {
    margin: 0 0 4px;
    font-size: 16px;
    font-weight: 600;
    color: #1d2129;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #94a3b8;
  }
}

.card-body {
  padding: 24px 28px 8px;
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 20px;
}

/* 表单字段 */
.field {
  margin-bottom: 18px;

  label {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 500;
    color: #475569;
  }

  .el-input {
    width: 100%;
  }
}

.field-hint {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #cbd5e1;
}

.field-row {
  display: flex;
  gap: 20px;

  .field {
    flex: 1;
  }
}

/* 开关行 */
.switch-row {
  display: flex;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid #f1f5f9;

  &:last-of-type {
    border-bottom: none;
  }
}

.switch-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f0f5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;

  i {
    font-size: 18px;
    color: #409eff;
  }
}

.switch-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.switch-label {
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
}

.switch-desc {
  font-size: 12px;
  color: #94a3b8;
}

/* 按钮 */
.save-btn {
  padding: 10px 28px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  background: #409eff !important;
  border-color: #409eff !important;
  color: #fff !important;

  &:hover, &:focus {
    background: #66b1ff !important;
    border-color: #66b1ff !important;
  }
}
</style>
